
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Rooms = lazy(() => import('../pages/rooms/page'));
const RoomDetail = lazy(() => import('../pages/rooms/[id]/page'));
const RentalGuide = lazy(() => import('../pages/rental-guide/page'));
const LifeSupport = lazy(() => import('../pages/life-support/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/rooms',
    element: <Rooms />,
  },
  {
    path: '/rooms/:id',
    element: <RoomDetail />,
  },
  {
    path: '/rental-guide',
    element: <RentalGuide />,
  },
  {
    path: '/life-support',
    element: <LifeSupport />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
